import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ThemeForm from '../Form';
import { createTheme } from '@resources/Theme/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createTheme, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createTheme(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.theme.create',
						defaultMessage:
							'A new Theme has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.theme',
					defaultMessage: 'Create Theme',
				})}
			</Title>
			<Section className="mb-5">
				<ThemeForm onSubmit={handleSubmit} {...props} module={module} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	themes,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		themes,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createTheme,
})(Create);
